import {useCallback} from 'react';
import getStudyDoc from '../../api/study/getStudyDoc';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export interface GetStudyVariables {
  moduleId: string;
  topic: string;
}

export function useGetStudy(variables: GetStudyVariables) {
  const {moduleId, topic} = variables;
  const shouldLoad = Boolean(moduleId && topic);

  const load = useCallback(() => getStudyDoc(moduleId, topic), [moduleId, topic]);

  const {
    data: study,
    loading,
    error,
    refetch,
  } = useFunctionRun(load, {
    skip: !shouldLoad,
  });

  return {
    study: study ?? undefined,
    loading,
    error,
    refetch,
  };
}
